import { Injectable } from '@angular/core';
import { ModalsComponent } from 'src/app/common/modals/modals.component';
import { PreviewImageComponent } from 'src/app/common/preview-image/preview-image.component';

@Injectable({
  providedIn: 'root',
})
export class PreviewImageService {
  // data
  component!: PreviewImageComponent;

  bindComponent(component: PreviewImageComponent) {
    this.component = component;
  }

  getInstance() {
    return this.component;
  }
}
